module.exports = __webpack_public_path__ + "files/c172a556bf1cbf4307a41dfd5d94c634.png";